import script from "./voicePop.vue?vue&type=script&setup=true&lang=js"
export * from "./voicePop.vue?vue&type=script&setup=true&lang=js"

import "./voicePop.vue?vue&type=style&index=0&id=00d8f3f1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00d8f3f1"]])

export default __exports__